<template>

<core-modal v-on:close="onCancelClick" icon="caret-left" :nopadding="true">

	<template v-slot:head>

		Move Tag

	</template>

	<template v-slot:default>

		<template v-for="item in items">

			<com-family :key="item.id" :family="item" :is-moving="true" :is-selected="is.selected === item.id" v-on:click="onMoveClick" />

		</template>

	</template>

	<template v-slot:foot>

		<core-button theme="blue" :loading="is.loading" :disabled="!is.selected" v-on:click.native="onConfirmClick">Confirm</core-button>
		<core-button theme="plain" v-on:click.native="onCancelClick">Cancel</core-button>

	</template>

</core-modal>

</template>

<script>

import comFamily from './manage/Family'

export default {

	props: ['data'],

	components: {
		'com-family': comFamily
	},

	data: function() {

		return {

			is: {
				loading: false,
                selected: false
			}

		}

	},

	computed: {

		items: function() {

			var items = []

			this.$_.each(this.families, function(family) {

                if(!this.isFamily || this.isFamily !== family.id) {

                    family = this.$util.copy(family)
                    family.sort = family.name
                    family.isFamily = true

				    items.push(family)

                }

			}.bind(this))

			items = this.$_.sortBy(items, function(item) {

				return item.sort.toLowerCase()

			})

            if (this.isFamily) {

                items.push({
                    id: 'none',
                    name: 'No family',
                    public: 1,
                    attachments: this.tags.length
                })

            }

			return items

		},

		tags: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

				return !tag.family

			})

		},

		families: function() {

			return this.$store.getters['data/tagFamilies/list']

		},

		tag: function() {

			return this.$store.getters['data/tags'][this.data.tag]

		},

        family: function() {

            return (this.isFamily) ? this.$_.find(this.$store.getters['data/tagFamilies/list'], function(family) {

                return family.id === this.tag.family

            }.bind(this)) : false

        },

		isFamily: function() {

			return this.tag.family

		}

	},

	methods: {

        onMoveClick: function(to) {

            this.is.selected = to

        },

		onConfirmClick: function() {

            this.is.loading = true

			this.$store.dispatch('api/tags/move', {
				tag: this.data.tag,
                to: this.is.selected
			}).then(function(tag) {

				this.$store.commit('data/tags/update', [tag])

				this.$emit('close')

                this.$pubsub.$emit('open.modal', {
                    id: 'tagEdit',
                    tag: this.data.tag
                })

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this)) 

		},

		onCancelClick: function() {

			this.$emit('close')

			this.$pubsub.$emit('open.modal', {
				id: 'tagEdit',
				tag: this.data.tag
			})

		}

	}

}

</script>

<style scoped>

</style>